import { License, User } from "common/gql";
import { FeatureFlagNames } from "../../interfaces/enums";
import store from "../../state/store";

export default class SessionUtils
{
	/**
	 * look in the session info to see if the given feature flag is enabled
	 *
	 * @static
	 * @param {string} featureName
	 * @returns {boolean}
	 * @memberof Utils
	 */
	static isFeatureFlagEnabled(featureName: FeatureFlagNames): boolean
	{
		const sessionInfo = store.getState().userModule.sessionInfo;
		const currentOrganization: string = store.getState().userModule.currentOrganization;
		const featureFlags = sessionInfo?.companies?.find(company => company.uuid === currentOrganization)?.settings?.features;
		return featureFlags?.find(featureFlag => featureFlag.name === featureName)?.enabled ?? false;
	}

	static countFeatureFlagsEnabled(): number
	{
		let count = 0;
		for(const featureFlag in FeatureFlagNames)
		{
			const flagValue = FeatureFlagNames[featureFlag];
			if(SessionUtils.isFeatureFlagEnabled(flagValue))
			{
				count++;
			}
		}
		return count;
	}
	
	static getAuthorLicense(author: User): string
	{
		if(!author.licenses?.nodes?.length) return "No License";
		
		const worklinkLicenses = author.licenses.nodes;
		return SessionUtils.getDominantLicense(worklinkLicenses as License[]);
	}

	static getDominantLicense(worklinkLicenses: License[]): string
	{
		// fail safe
		if(!worklinkLicenses?.some(license => license?.state === "ACTIVE")) 
		{
			return "No License";
		}

		// find license
		if(worklinkLicenses.some(license => license?.type === "AUTHOR"))
		{
			return "Author";
		}
		else if(worklinkLicenses.some(license => license?.type === "REVIEWER"))
		{
			return "Reviewer";
		}
		else if(worklinkLicenses.some(license => license?.type === "VIEWER"))
		{
			return "Viewer";
		}

		// no Create license; could be for the app but it's meaningless for us
		return "Unknown";
	}
}